import React from 'react';
interface ChoiceGroupProps<T extends string> {
  label: string;
  name: string;
  value: T;
  options: {
    value: T;
    label: string;
  }[];
  onChange: (value: T) => void;
  required?: boolean;
}
export function ChoiceGroup<T extends string>({
  label,
  name,
  value,
  options,
  onChange,
  required
}: ChoiceGroupProps<T>) {
  return <fieldset data-id="element-1088" data-mp="1szqmxcrlm6ln">
      <legend className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1089" data-mp="1szgtff7chhb7">
        {label} {required && <span className="text-red-500" data-id="element-1090" data-mp="1e2pv799eqbn6">*</span>}
      </legend>
      <div className="flex flex-wrap gap-2" data-id="element-1091" data-mp="1j3dsgco8bopu">
        {options.map(opt => {
        const checked = value === opt.value;
        return <label key={opt.value} className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-sm cursor-pointer whitespace-nowrap transition-colors duration-150 ${checked ? 'border-seform-orange bg-orange-50 text-seform-navy font-medium' : 'border-slate-200 text-slate-600 hover:border-slate-300'}`} data-id="element-1092" data-mp="155fl3r8bssju">
              <input type="radio" name={name} value={opt.value} checked={checked} onChange={() => onChange(opt.value)} className="text-seform-orange focus:ring-seform-orange" data-id="element-1093" data-mp="1p52addkambsj" />
              {opt.label}
            </label>;
      })}
      </div>
    </fieldset>;
}